import { render, staticRenderFns } from "./MemberPremoney.vue?vue&type=template&id=078a1781&scoped=true"
import script from "./MemberPremoney.vue?vue&type=script&lang=js"
export * from "./MemberPremoney.vue?vue&type=script&lang=js"
import style0 from "./MemberPremoney.vue?vue&type=style&index=0&id=078a1781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a1781",
  null
  
)

export default component.exports